import { Divider } from '@mui/material';
import * as React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  UseFormReturn,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmployeeSelect } from '~/components/GenericForm/EmployeeSelect';
import {
  EmployeeProposalFormData,
  EmployeeProposalResponsibleHRSelectorSettings,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

type PropsType<TFormData extends FieldValues> = {
  form: UseFormReturn<TFormData>;
  control: Control<TFormData>;
  selectorSettings: EmployeeProposalResponsibleHRSelectorSettings;
  disabled?: boolean;
};

export const ProposalResponsibleHRSelect = <
  TFormData extends EmployeeProposalFormData,
>(
  props: PropsType<TFormData>,
) => {
  const {
    form: { control },
    selectorSettings,
    disabled,
  } = props;
  const { t } = useTranslation();

  return selectorSettings.enabled ? (
    <>
      <Divider>{t('proposalHandling')}</Divider>
      <Controller
        name={'responsibleHR' as Path<TFormData>}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <EmployeeSelect
              label={t('laHRResponsible')}
              value={value}
              onChange={onChange}
              optionEmployeeIds={selectorSettings.options}
              FormControlProps={{
                fullWidth: true,
              }}
              fullWidth={true}
              disabled={disabled}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
    </>
  ) : (
    <></>
  );
};
